/*
* Utility Library.
* @global _ - lodash.
* @global $,jQuery - jquery.
* */
require('expose-loader?_!lodash');

/*
* Expand jQuery.
* */

/*
* Expand Custom Function.
* */

/*
* Set html5 Element for <ie8.
* */
;((doc, e) => {
  if(!doc) { return; }
  _.each(e, (e) => doc.createElement(e));
  return true;
})(window ? window['document'] : false, require('./_plugin/html5tag'));



/*
* expand setInterval.
* @usage
* var timer = jQuery.fn.timer(()=>{
* });
* timer.stop();
* */
jQuery.fn.timer = require('./_plugin/timer');

/*
* expand requestAnimationFrame.
* @usage
* var timer = jQuery.fn.frame(()=>{
*   ...
* }, 30);
* timer.stop();
* */
jQuery.fn.frame = require('./_plugin/animationframe');



// WEBPACK FOOTER //
// ../_mrk_src/js/lib.js